import React, { useState, useEffect } from 'react';
import './AboutUs.css';
import buildingImage from '../../assets/imgs/us/our_building.jpg';
import organizationVideo from '../../assets/imgs/us/us_video.mp4';
import logoImage from '../../assets/imgs/2.png';
import Footer from '../../components/Footer/Footer';

const AboutUs = () => {
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem('selectedLanguage') || 'KU';
  });

  useEffect(() => {
    const savedLang = localStorage.getItem('selectedLanguage') || 'KU';
    setCurrentLang(savedLang);

    const handleLanguageChange = (event) => {
      setCurrentLang(event.detail);
      localStorage.setItem('selectedLanguage', event.detail);
    };
    window.addEventListener('languageChange', handleLanguageChange);
    return () => window.removeEventListener('languageChange', handleLanguageChange);
  }, []);

  const content = {
    EN: {
      title: 'Reboon Organization for Development and Training',
      scopeTitle: 'Scope of Work and Address',
      scopeText: 'The main headquarters of the organization is in the city of (Sulaymaniyah Governorate). As needed, it branches out inside and outside the country.',
      fieldTitle: 'Field of Work',
      fieldText: '(Humanitarian Cooperation and Education)',
      definitionTitle: 'Organization Definition',
      definitionText: 'An independent, non-profit, non-governmental and impartial organization. It works to serve all segments of society without discrimination with the aim of advancing individuals in society in terms of education and awareness.',
      goalsTitle: 'Organization Goals',
      goals: [
        'Spreading awareness about important topics to all classes and segments of society',
        'Taking all paths that serve the Kurdish community through material and moral means',
        'Protecting the general and high interests of the Kurdistan Region',
        'Spreading the culture of peaceful coexistence, accepting each other, and accepting different opinions',
        'Striving to develop dialogue and tolerance in society'
      ],
      howTitle: 'How It Works',
      how: [
        'All forms of peaceful civil work',
        'Research and investigation',
        'Meetings, seminars, conferences, visits and open dialogue'
      ],
      activitiesTitle: 'Reboon Organization Activities',
      appTitle: 'Travel App (Gashti-e-Wain) consists of the following sections:',
      appSections: [
        'Holy places with images, information and location',
        'Health guide and first aid section',
        'Necessary words and phrases in Arabic language specific to Umrah travel',
        'Preparing the Umrah section with the importance and method of performance, Sunnahs, necessities of Umrah, questions and answers, Sunnahs of performing the deceased prayer and supplications',
        'Dhikr section with the importance of performance',
        'Currency exchange and necessary travel numbers',
        'Audio library and PDF',
        'Qibla compass and prayer times and Quran recitation'
      ]
    },
    KU: {
      title: 'ڕێكخراوی ڕێبوون بۆپه‌روه‌رده‌ و ڕاهێنان',
      scopeTitle: 'سنورى کارکردن و ناونیشان',
      scopeText: 'بنکەى گشتى رێکخراو لە شاری (پارێزگای  سلێمانی) دەبێ .بە پێی پێویست لە ناوەو دەرەوەى ووڵات لق دەکاتەوە .',
      fieldTitle: 'بوارى کارکردن',
      fieldText: '( هاوكاری مرۆی و په‌روه‌رده)',
      definitionTitle: 'پێناسەى رێکخراو',
      definitionText: 'ڕێکخراوێکی ناحکومی سەربەخۆی قازانج نەویست و بێلایەنە. كارده‌كات بۆ خزمه‌تكردنی گشت چینه‌كانی كۆمه‌ڵگا به‌بێ جیاوازی به‌مه‌به‌ستی به‌ره‌و پێشبردنی تاكه‌كانی ناو كۆمه‌ڵگه‌ له‌ڕوی په‌روه‌رده‌ و هۆشیاریه‌وه‌.',
      goalsTitle: 'ئامانجەکانی رێکخراو',
      goals: [
        'بڵاوكردنه‌وه‌ی هۆشیاری له‌ بابه‌ته‌ دروسته‌كان بۆ سه‌رجه‌م چین و توێژه‌كانی كۆمه‌ڵگه‌',
        'گرتنه‌به‌ری هه‌موو ئه‌و ڕێگایانه‌ی خزمه‌ت به‌ كۆمه‌ڵگه‌ی كوردی ده‌كات به‌ڕێگه‌ی مادی و مه‌عنه‌وی.',
        'پاراستنی بەرژەوەندییە گشتی و باڵاکانی هەرێمی کوردستان.',
        'بلاوكردنه‌وه‌ی كه‌لتوری بێكه‌وه‌ ژیان و قه‌بولكردنی یه‌كتر و قه‌بولكردنی بیرورای جیاواز.',
        'هه‌وڵدان بۆ گه‌شه‌پێدانی دیالۆگ و گیانی لێبورده‌یی له‌ كومه‌ڵگادا.'
      ],
      howTitle: 'چۆنیەتى کارکردن',
      how: [
        'هەموو شێوازێکى کارى مەدەنی ئاشتیخوازانە.',
        'توێژینەوەو ڕاپرسى .',
        'کۆبوونەوەو سیمینار و کۆنفرانس و دیدارو دیالۆگى کراوە .'
      ],
      activitiesTitle: 'كاروچالاكی ڕێكخراوی ڕێبوون:',
      appTitle: 'ئه‌پڵیكه‌یشنی (گه‌شتی ئه‌وین) کەلەم بەشانە پێکدێت:',
      appSections: [
        'شوێنە پیرۆزەکان بەوێنە و زانیاری و لۆكه‌یشنه‌كه‌یەوە',
        'به‌شی ڕێنمای ته‌ندروستی و فریاگوزاری سەرەتای',
        'وشه‌ و رسته‌ پێویسته‌كانی زمانی عه‌ره‌بی تایبه‌ت به‌سه‌فه‌ری عومره‌',
        'ئاماده‌كردنی به‌شی عومره‌ به‌ گرنگی و شێوازی ئه‌نجامدانی و سونه‌ته‌كانی و شته‌ پێویستیه‌كانی عومره‌ و پرسار و وه‌ڵام و سونه‌تی ئه‌نجامدای نوێژی مردوو و دوعاكان',
        'به‌شی زیكره‌كان به‌ گرنگی ئه‌نجامدانیه‌وه‌',
        'گۆڕینی درا و ژمارە پێویستەکانی سەفەر',
        'کتێبخانەی دەنگی و پیدیئێف',
        'قیبلەنما و کاتەکانی بانگ و قورئان خوێندن'
      ]
    },
    AR: {
      title: 'منظمة ریبوون للتنمية والتدريب',
      scopeTitle: 'نطاق العمل والعنوان',
      scopeText: 'المقر الرئيسي للمنظمة في مدينة (محافظة السليمانية). حسب الحاجة، تتفرع داخل وخارج البلاد.',
      fieldTitle: 'مجال العمل',
      fieldText: '(التعاون الإنساني والتعليم)',
      definitionTitle: 'تعريف المنظمة',
      definitionText: 'منظمة مستقلة غير حكومية وغير ربحية ومحايدة. تعمل على خدمة جميع شرائح المجتمع دون تمييز بهدف تطوير الأفراد في المجتمع من حيث التعليم والوعي.',
      goalsTitle: 'أهداف المنظمة',
      goals: [
        'نشر الوعي حول المواضيع المهمة لجميع الطبقات والشرائح المجتمعية',
        'اتخاذ جميع السبل التي تخدم المجتمع الكردي من خلال الوسائل المادية والمعنوية',
        'حماية المصالح العامة والعليا لإقليم كردستان',
        'نشر ثقافة التعايش السلمي وقبول بعضنا البعض وقبول الآراء المختلفة',
        'السعي لتطوير الحوار والتسامح في المجتمع'
      ],
      howTitle: 'كيفية العمل',
      how: [
        'جميع أشكال العمل المدني السلمي',
        'البحث والتحقيق',
        'الاجتماعات والندوات والمؤتمرات والزيارات والحوار المفتوح'
      ],
      activitiesTitle: 'أنشطة منظمة ریبوون',
      appTitle: 'تطبيق السفر (جشتي وين) يتكون من الأقسام التالية:',
      appSections: [
        'الأماكن المقدسة مع الصور والمعلومات والموقع',
        'قسم دليل الصحة والإسعافات الأولية',
        'الكلمات والعبارات الضرورية باللغة العربية خاصة بسفر العمرة',
        'إعداد قسم العمرة بأهمية وطريقة الأداء والسُنن وضروريات العمرة والأسئلة والأجوبة وسُنن أداء صلاة الميت والدعوات',
        'قسم الذكر بأهمية الأداء',
        'صرف العملة والأرقام الضرورية للسفر',
        'مكتبة صوتية وPDF',
        'بوصلة القبلة وأوقات الصلاة وتلاوة القرآن'
      ]
    },
    TR: {
      title: 'Reboon Kalkınma ve Eğitim Organizasyonu',
      scopeTitle: 'Çalışma Kapsamı ve Adres',
      scopeText: 'Organizasyonun genel merkezi (Süleymaniye İli) şehrindedir. Gerektiğinde ülke içinde ve dışında şube açar.',
      fieldTitle: 'Çalışma Alanı',
      fieldText: '(İnsani İşbirliği ve Eğitim)',
      definitionTitle: 'Organizasyon Tanımı',
      definitionText: 'Bağımsız, kâr amacı gütmeyen, hükümet dışı ve tarafsız bir organizasyon. Toplumun tüm kesimlerine ayrım gözetmeksizin hizmet etmek için çalışır ve toplumdaki bireyleri eğitim ve bilinç açısından ilerletmeyi amaçlar.',
      goalsTitle: 'Organizasyon Hedefleri',
      goals: [
        'Önemli konularda toplumun tüm sınıf ve kesimlerine farkındalık yaymak',
        'Maddi ve manevi yollarla Kürt toplumuna hizmet eden tüm yolları benimsemek',
        'Kürdistan Bölgesi\'nin genel ve yüksek çıkarlarını korumak',
        'Barışçıl birlikte yaşama kültürünü, birbirini kabul etmeyi ve farklı görüşleri kabul etmeyi yaymak',
        'Toplumda diyalog ve hoşgörü geliştirmeye çalışmak'
      ],
      howTitle: 'Nasıl Çalışır',
      how: [
        'Barışçıl sivil çalışmanın her türlü şekli',
        'Araştırma ve soruşturma',
        'Toplantılar, seminerler, konferanslar, ziyaretler ve açık diyalog'
      ],
      activitiesTitle: 'Reboon Organizasyonu Faaliyetleri',
      appTitle: 'Seyahat Uygulaması (Gashti-e-Wain) şu bölümlerden oluşur:',
      appSections: [
        'Görüntüler, bilgiler ve konum ile kutsal yerler',
        'Sağlık rehberi ve ilk yardım bölümü',
        'Umre seyahatine özel Arapça dilinde gerekli kelimeler ve ifadeler',
        'Umre bölümünün önemi ve uygulama yöntemi, sünnetler, umre gereksinimleri, sorular ve cevaplar, ölü namazı ve duaların sünnetleri ile hazırlanması',
        'Uygulamanın önemi ile zikir bölümü',
        'Döviz değişimi ve gerekli seyahat numaraları',
        'Sesli kütüphane ve PDF',
        'Kıble pusulası ve namaz vakitleri ve Kuran okuma'
      ]
    }
  };

  const pageContent = content[currentLang] || content.KU;

  return (
    <div className="about-us-page">
      {/* Hero Section with Building Image and Logo */}
      <div className="hero-section">
        <div className="hero-image-container">
          <img src={buildingImage} alt="Reboon Organization Building" className="hero-image" />
          <div className="hero-overlay">
            <div className="container hero-content-wrapper">
              <div className="hero-logo-container">
                <img src={logoImage} alt="Reboon Logo" className="hero-logo" />
              </div>
              <h1 className="hero-title">{pageContent.title}</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Video Section */}
      <div className="video-section">
        <div className="video-container">
          <div className="video-container-inner">
            <video
              className="organization-video"
              controls
              autoPlay
              loop
            >
              <source src={organizationVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="about-us-content">
          {/* Two Column Layout for Key Info */}
          <div className="info-grid">
            {/* Scope of Work */}
            <div className="content-section">
              <h2 className="section-title">{pageContent.scopeTitle}</h2>
              <p className="section-text">{pageContent.scopeText}</p>
            </div>

            {/* Field of Work */}
            <div className="content-section">
              <h2 className="section-title">{pageContent.fieldTitle}</h2>
              <p className="section-text highlight">{pageContent.fieldText}</p>
            </div>
          </div>

          {/* Organization Definition - Full Width */}
          <div className="content-section featured-section">
            <h2 className="section-title">{pageContent.definitionTitle}</h2>
            <p className="section-text">{pageContent.definitionText}</p>
          </div>

          {/* Organization Goals */}
          <div className="content-section">
            <h2 className="section-title">{pageContent.goalsTitle}</h2>
            <ol className="goals-list">
              {pageContent.goals.map((goal, index) => (
                <li key={index} className="goal-item">
                  {goal}
                </li>
              ))}
            </ol>
          </div>

          {/* How It Works */}
          <div className="content-section">
            <h2 className="section-title">{pageContent.howTitle}</h2>
            <ul className="how-list">
              {pageContent.how.map((item, index) => (
                <li key={index} className="how-item">
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Activities */}
          <div className="content-section">
            <h2 className="section-title">{pageContent.activitiesTitle}</h2>
            <h3 className="subsection-title">{pageContent.appTitle}</h3>
            <ul className="app-sections-list">
              {pageContent.appSections.map((section, index) => (
                <li key={index} className="app-section-item">
                  {section}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;
